<svg
  [attr.preserveAspectRatio]="preserveAspectRatio ? preserveAspectRatio : null"
  [attr.viewBox]="viewBox ? viewBox : null"
  [attr.width]="viewBox ? null : (width$ | async)"
  [attr.height]="viewBox ? null : (height$ | async)"
></svg>
<fin-tooltip [tooltip$]="tooltip$"></fin-tooltip>
@if (legendText$ | async) {
  <fin-chart-legend [text$]="legendText$"></fin-chart-legend>
}
